import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// Removable demo entry: its public route never mounts workspace/auth providers.
const App = React.lazy(() =>
  import("./product/App").then((m) => ({ default: m.App })),
);
const IntakeDemo = React.lazy(() => import("./intake-demo/IntakeDemo"));
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <React.Suspense
        fallback={
          <main role="status" style={{ padding: 32 }}>
            Opening Aitropic…
          </main>
        }
      >
        <Routes>
          <Route path="/intake-demo/*" element={<IntakeDemo />} />
          <Route path="*" element={<App />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  </React.StrictMode>,
);
